import React, { useEffect } from 'react';

const ExitForm = (props) => {
  useEffect(() => {
  }, [props.node]);
  return (
    <span>When the user arrive on this step, they will exit the journey.</span>
  );
};

export default ExitForm;
